import Cleave from "cleave.js"
import 'cleave.js/dist/addons/cleave-phone.ru'
import "fslightbox"
import { FADE, Splide } from "@splidejs/splide"
import { Grid } from '@splidejs/splide-extension-grid'
import Dropzone from "./_Dropzone"
import InputContollerGroup from "./_InputControllerGroup"
import Popup from "./_Popup"
import Quantity from "./_Quantity"
import Spoiler from "./_Spoiler"
import Animate from "./_Animate"
import SyncedInputs from "./_SyncedInputs"
import { bindSplideArrows, breakpoints, headerHeightToCSS, toggleNoscrollBody } from "./_helpers"
import * as echarts from 'echarts'

document.addEventListener('DOMContentLoaded', function () {
	initPopups()
	// initTabs()
	initPhoneMask()
	// initQuantity()
	initSpoilers()
	// initInputControllerGroups()
	initSyncedInputs()
	// initDropzone()
	// initAnimates()
	initSliders()
	initCharts()
	initHeaderDrops()
	initHeaderSearch()
	initMenu()
	initQna()
})

window.addEventListener("load", function () {
	headerHeightToCSS()
})

function initHeaderSearch() {
	let search = document.querySelector(".header__search")
	let opener = document.querySelector(".header__search-opener")
	let closer = search && search.querySelector(".header__search__closer")

	opener && opener.addEventListener("click", () => {
		search.classList.add("is-active")
	})
	closer && closer.addEventListener("click", () => {
		search.classList.remove("is-active")
	})
}

function initQna() {
	document.querySelectorAll(".qna").forEach(block => {
		block.querySelector("[data-qna-toggle]")?.addEventListener("click", function () {
			block.classList.add("qna--show-all")
			this.remove()
		})
	})
}

function initMenu() {
	let menu = document.querySelector(".menu")
	let header = document.querySelector(".header")
	let burger = document.querySelector(".header__burger")

	burger.addEventListener("click", function () {
		toggleNoscrollBody()
		menu.classList.toggle("is-active")
		header.classList.toggle("is-menu-opened")
		burger.classList.toggle("is-active")
	})

	document.querySelectorAll(".menu__nav .menu__nav").forEach(botLevel => {
		botLevel.closest(".menu__nav__item").addEventListener("click", () => {
			botLevel.classList.add("is-active")
		})
		botLevel.querySelector(".menu__nav__item--back").addEventListener("click", (event) => {
			event.stopPropagation()
			botLevel.classList.remove("is-active")
		})
	})
}

function initHeaderDrops() {
	let togglers = document.querySelectorAll(".header__link[data-header-drop]")
	let drops = document.querySelectorAll(`.header__drop[data-header-drop]`)

	togglers.forEach(toggler => {
		toggler.addEventListener("click", () => {
			let isOpened = toggler.classList.contains("is-active")

			togglers.forEach(toggler => {
				toggler.classList.remove("is-active")
			})
			drops.forEach(drop => {
				drop.classList.remove("is-active")
			})
			toggler.classList.toggle("is-active", !isOpened);
			[...drops].find(drop => {
				return drop.dataset.headerDrop == toggler.dataset.headerDrop
			}).classList.toggle("is-active", !isOpened)
		})
	})

	drops.forEach(drop => {
		drop.classList.add("is-initialized")
	})
}

function initCharts() {
	// в каждом табе
	document.querySelectorAll(".management-chart__tabs__content").forEach(container => {
		let tabController = container.querySelector("input[type=radio]")
		// если таб активен
		if (tabController.checked) {
			itinChart()
		} else {
			// иначе когда станет активен через SyncedInputs
			tabController.addEventListener("syncChange", itinChart, {
				once: true
			})
		}

		function itinChart() {
			container.querySelectorAll(".management-chart__card__chart").forEach(container => {
				// табы временного диапазона
				let tabs = container.querySelectorAll(".management-chart__card__tab")
				// контейнер для чарта
				let chart = container.querySelector(".management-chart__card__data")

				let Chart = echarts.init(chart)
				Chart.setOption({
					tooltip: {
						trigger: 'axis',
						formatter: function (params, ticket, callback) {
							return `${params[0].value >= 0 ? "+" : "-"}${params[0].value}%`
						},
						padding: [8, 12],
						borderRadius: 10,
						shadowColor: 'rgba(28, 42, 67, 0.1)',
						shadowBlur: 20,
						shadowOffsetX: 0,
						shadowOffsetY: 4,
						textStyle: {
							fontFamily: "Formular",
							fontSize: 26,
							color: "#171616"
						},
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#171616',
								fontFamily: "Formular",
								precision: 1,
								shadowColor: 'rgba(28, 42, 67, 0.1)',
								shadowBlur: 20,
								shadowOffsetX: 0,
								shadowOffsetY: 4,
								padding: [6, 12],
								borderRadius: 999,
								fontSize: 14,
								margin: -16,
								formatter: function (params) {
									let fixed = Number(params.value).toFixed(1)
									let isFull = !Boolean(fixed % 1)

									return typeof params.value == "number" ? `${isFull ? Number(params.value).toFixed(0) : fixed} %` : params.value
								}
							},
							lineStyle: {
								color: "rgba(205, 32, 113, 0.2)",
								type: "solid",
								width: 2,
							},
							crossStyle: {
								color: "rgba(205, 32, 113, 0.2)",
								type: "solid",
								width: 2,
							},
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: JSON.parse(container.querySelector('.management-chart__card__tab.is-active').dataset.parameter),
						axisLine: {
							onZero: false,
							show: false
						},
						axisTick: {
							show: false
						},
						offset: 20
					},
					grid: {
						top: 10,
						right: 40,
						bottom: 50,
						left: 50
					},
					yAxis: {
						type: 'value',
						boundaryGap: [0.2, 0.2],
						axisTick: {
							show: false
						},
						axisLabel: {
							formatter: '{value} %'
						}
					},
					color: "#CD2071",
					series: [
						{
							data: JSON.parse(container.querySelector('.management-chart__card__tab.is-active').dataset.values),
							type: 'line',
							areaStyle: {
								origin: "start",
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{
										offset: 0,
										color: 'rgba(205, 32, 113, 0.28)'
									},
									{
										offset: 1,
										color: 'rgba(205, 32, 113, 0)'
									}
								])
							},
							showSymbol: false,
							symbolSize: 14,
							symbol: 'circle'
						}
					]
				})

				// при выборе таба временного диапазона изменить набор параметров и значений
				tabs.forEach(tab => {
					let parameter = JSON.parse(tab.dataset.parameter)
					let values = JSON.parse(tab.dataset.values)

					tab.addEventListener("click", () => {
						tabs.forEach(tab => {
							tab.classList.remove("is-active")
						})
						tab.classList.add("is-active")
						Chart.setOption({
							xAxis: { data: parameter },
							series: [{ data: values }]
						})
					})
				})
			})
		}
	})
}

function initSliders() {
	Splide.defaults = {
		gap: 8,
		arrows: false,
		breakpoints: {
			[breakpoints.mobile]: {
				gap: 4,
			}
		}
	}

	document.querySelectorAll(".splide--1").forEach(slider => {
		let splide = new Splide(slider, {
			perPage: 3,
			perMove: 1,
			pagination: false,
			breakpoints: {
				[breakpoints.mobile]: {
					perPage: 1,
					pagination: true,
				}
			}
		}).mount()

		while (!arrows) {
			var parent = parent?.parentElement ?? slider.parentElement
			var arrows = parent.querySelector(".splide__arrows")
		}

		if (arrows) {
			bindSplideArrows(splide, true, arrows)
		}
	})

	document.querySelectorAll(".splide--2").forEach(slider => {
		let articleParent = slider.closest("article")
		let counter = articleParent.querySelector(".slider__counter")

		let splide = new Splide(slider, {
			perPage: 1,
			perMove: 1,
			pagination: false,
			breakpoints: {
				[breakpoints.mobile]: {
					pagination: true,
				}
			}
		}).mount()

		if (counter) {
			let counterCurrent = counter.querySelector(".slider__counter__current span")
			let counterTotal = counter.querySelector(".slider__counter__total span")
			counterTotal.innerText = `${splide.Components.Slides.getLength()}`
			counterCurrent.innerText = `${1}`
			splide.on("moved", (newPos) => {
				counterCurrent.innerText = `${newPos + 1}`
			})
		}

		let arrows = articleParent.querySelector(".splide__arrows")

		if (arrows) {
			bindSplideArrows(splide, true, arrows)
		}
	})

	document.querySelectorAll(".splide--3").forEach(slider => {
		let splide = new Splide(slider, {
			perPage: 1,
			perMove: 1,
			pagination: false,
			breakpoints: {
				[breakpoints.mobile]: {
					pagination: true,
				}
			}
		}).mount()

		let arrows = slider.closest("article").querySelectorAll(".splide__arrows")

		if (arrows) {
			bindSplideArrows(splide, true, ...arrows)
		}
	})

	document.querySelectorAll(".splide--4").forEach(slider => {
		let splide = new Splide(slider, {
			perPage: 2,
			perMove: 1,
			pagination: false,
			breakpoints: {
				[breakpoints.mobile]: {
					pagination: true,
					perPage: 1,
				}
			}
		}).mount()

		let arrows = slider.closest("article").querySelector(".splide__arrows")

		if (arrows) {
			bindSplideArrows(splide, true, arrows)
		}
	})

	document.querySelectorAll(".splide--5").forEach(slider => {
		let articleParent = slider.closest("article")
		let arrows = articleParent.querySelector(".splide__arrows")
		let counter = articleParent.querySelector(".strategy__counter")
		let counterCurrent = counter.querySelector(".strategy__counter__number__current span")
		let counterTotal = counter.querySelector(".strategy__counter__number__total span")
		let radios = [...slider.querySelectorAll(".strategy__card__radios")].map(current => {
			return current.querySelectorAll(".strategy__card__radio input")
		})
		let questionsDone = 0


		let splide = new Splide(slider, {
			perPage: 3,
			perMove: 1,
			pagination: false,
			focus: "start",
			breakpoints: {
				[breakpoints.mobile]: {
					perPage: 1,
				}
			}
		})

		splide.mount()

		counterTotal.innerText = `${splide.Components.Slides.getLength()}`
		counterCurrent.innerText = `${questionsDone}`

		radios.forEach(group => {
			function choose() {
				counterCurrent.innerText = `${++questionsDone}`
				if (questionsDone) {
					counter.classList.add("is-started")
				}

				if (questionsDone == splide.Components.Slides.getLength()) {
					articleParent.querySelector(".strategy").classList.add("is-done")
					articleParent.querySelector(".strategy__submit button").toggleAttribute("disabled", false)
				}

				group.forEach(button => {
					button.removeEventListener("change", choose)
				})
			}

			group.forEach(button => {
				button.addEventListener("change", choose)
				button.addEventListener("change", () => {
					splide.go(">")
				})
			})
		})

		if (arrows) {
			bindSplideArrows(splide, false, arrows)
		}
	})

	document.querySelectorAll(".splide--6").forEach(slider => {
		new Splide(slider, {
			perPage: 1,
			perMove: 1,
			pagination: false,
			grid: {
				rows: 2,
				cols: 1,
				gap: {
					row: 4,
				},
			},
			breakpoints: {
				[breakpoints.mobile]: {
					pagination: true,
					grid: {
						rows: 1,
						cols: 1,
						gap: {
							row: 4,
						},
					},
				}
			}
		}).mount({ Grid })

	})

	document.querySelectorAll(".splide--7").forEach(slider => {
		let splide = new Splide(slider, {
			perPage: 1,
			perMove: 1,
			pagination: true,
			breakpoints: {
				[breakpoints.mobile]: {
				}
			}
		}).mount()

		let arrows = slider.closest("article").querySelector(".splide__arrows")

		if (arrows) {
			bindSplideArrows(splide, true, arrows)
		}
	})

	document.querySelectorAll(".splide--8").forEach(slider => {
		let splide = new Splide(slider, {
			perPage: 1,
			perMove: 1,
			pagination: true,
			mediaQuery: "min",
			breakpoints: {
				[breakpoints.mobile]: {
					destroy: true
				}
			}
		}).mount()

		let arrows = slider.closest("article").querySelector(".splide__arrows")

		if (arrows) {
			bindSplideArrows(splide, true, arrows)
		}
	})

	document.querySelectorAll(".splide--9").forEach(slider => {
		let splide = new Splide(slider, {
			perPage: 1,
			perMove: 1,
			pagination: true,
			grid: {
				rows: 2,
				cols: 2,
				gap: {
					row: 8,
					col: 8,
				},
			},
			breakpoints: {
				[breakpoints.mobile]: {
					pagination: true,
					grid: {
						rows: 1,
						cols: 1,
					},
				}
			}
		}).mount({ Grid })

		let arrows = slider.closest("article").querySelector(".splide__arrows")

		if (arrows) {
			bindSplideArrows(splide, true, arrows)
		}
	})
}

function initSyncedInputs() {
	SyncedInputs.findGroups().forEach(group => {
		new SyncedInputs(...group)
	})
}

function initDropzone() {
	window.dropzones = []
	document.querySelectorAll(".dropzone").forEach(dropzone => {
		new Dropzone(dropzone)
	})
}

function initAnimates() {
	window.animates = [...document.querySelectorAll("[data-animate-group]")].map(group => new Animate(group))
}

function initQuantity() {
	document.querySelectorAll(".quantity").forEach(item => {
		new Quantity(item)
	})
}

function initInputControllerGroups() {
	InputContollerGroup.findGroups().forEach(group => {
		new InputContollerGroup(group)
	})
}

function initPhoneMask() {
	document.querySelectorAll('input[type=tel]').forEach(input => {
		new Cleave(input, {
			phone: true,
			phoneRegionCode: "RU",
			delimiter: "-",
			prefix: "+7",
			noImmediatePrefix: true
		})
	})
}

function initPopups() {
	window.popups = {};
	[...document.querySelectorAll("[data-popup]")].forEach(popup => {
		window.popups[popup.dataset.popup] = new Popup(popup)
	})
}

function initSpoilers() {
	document.querySelectorAll('.spoiler').forEach(spoiler => {
		new Spoiler(spoiler)
	})
}
